import { BackButton } from "./ui/BackButton";
import { CloseButton } from "./ui/CloseButton";

const LOGO_CLASSES = {
  square: "w-[51px] h-[51px] object-contain",
  rectangle: "max-h-[40px] max-w-[130px] w-auto h-auto object-contain",
} as const;

type LogoAspectRatio = keyof typeof LOGO_CLASSES;

function getLogoAspectRatio(): LogoAspectRatio {
  const el = document.querySelector('[data-app-layer-portal="form-portal"]');
  return el?.getAttribute("data-logo-aspect-ratio") === "rectangle" ? "rectangle" : "square";
}

interface HeaderProps {
  logoUrl?: string;
  logoAlt?: string;
  onBack?: () => void;
  onClose?: () => void;
  backButtonTestId?: string;
}

export function Header({ logoUrl, logoAlt, onBack, onClose, backButtonTestId }: HeaderProps) {
  const logoAspectRatio = getLogoAspectRatio();

  return (
    <header className="w-full bg-white py-4" role="banner">
      <div className="relative flex items-center justify-center">
        {onBack && <BackButton onClick={onBack} ariaLabel="Back" testId={backButtonTestId} />}

        {logoUrl && (
          <img
            src={logoUrl}
            alt={logoAlt || ""}
            className={LOGO_CLASSES[logoAspectRatio]}
          />
        )}

        {onClose && <CloseButton onClick={onClose} ariaLabel="Close" />}
      </div>
    </header>
  );
}
